<template>
  <div class="address-autocomplete">
    <label>Адрес</label>
    <input
      v-model="query"
      type="text"
      class="input"
      placeholder="Введите адрес"
      @input="onInputChange"
      @blur="onAddressBlur"
      autocomplete="off"
      autocorrect="off"
      autocapitalize="off"
      spellcheck="false"
    />

    <ul v-if="suggestions.length" class="suggestions">
      <li
        v-for="(item, index) in suggestions"
        :key="index"
        @click="selectSuggestion(item)"
      >
        {{ item.display_name }}
      </li>
    </ul>

    <div v-if="lat && lng" class="coordinates-display">
      <div><strong>Широта:</strong> {{ lat }}</div>
      <div><strong>Долгота:</strong> {{ lng }}</div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";

const query = ref("");
const suggestions = ref([]);
const lat = ref(null);
const lng = ref(null);
const emit = defineEmits(["update:addressData"]);
let debounceTimer = null;

// 🔹 Запрос к OpenStreetMap при вводе
async function onInputChange() {
  clearTimeout(debounceTimer);

  if (query.value.trim().length < 3) {
    suggestions.value = [];
    return;
  }

  debounceTimer = setTimeout(async () => {
    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(
          query.value
        )}&addressdetails=1&limit=5`
      );
      const data = await response.json();
      suggestions.value = data;
    } catch (error) {
      console.error("❌ Ошибка при поиске адреса:", error);
    }
  }, 400);
}

// 🔹 Когда пользователь кликает на подсказку
function selectSuggestion(item) {
  query.value = item.display_name;
  suggestions.value = [];

  lat.value = parseFloat(item.lat);
  lng.value = parseFloat(item.lon);

  console.log("📍 Выбран адрес:", item.display_name);
  console.log("📍 Координаты:", lat.value, lng.value);

  emit("update:addressData", {
    street: item.display_name,
    latitude: lat.value,
    longitude: lng.value,
  });
}

// 🔹 Если пользователь просто покинул поле (не выбрал)
async function onAddressBlur() {
  if (!query.value.trim()) return;

  try {
    const response = await fetch(
      `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(
        query.value
      )}&limit=1`
    );
    const data = await response.json();

    if (data.length > 0) {
      lat.value = parseFloat(data[0].lat);
      lng.value = parseFloat(data[0].lon);
      emit("update:addressData", {
        street: query.value,
        latitude: lat.value,
        longitude: lng.value,
      });
    }
  } catch (error) {
    console.error("❌ Ошибка геокодинга при blur:", error);
  }
}
</script>

<style scoped>
.address-autocomplete {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 630px;
  position: relative;
}

.input {
  width: 600px;
  padding: 12px 16px;
  border-radius: 16px;
  border: 1px solid #ccc;
  font-family: "Eastman-Regular", sans-serif;
  font-size: 16px;
}

.input::placeholder {
  color: #aaa;
}

html[data-theme="dark"] .input {
  background-color: #1e1e1e;
  border: 1px solid #555;
  color: #eee;
}

.suggestions {
  position: absolute;
  top: 100%;
  left: 0;
  width: 600px;
  background: white;
  border: 1px solid #ccc;
  border-radius: 10px;
  margin-top: 4px;
  list-style: none;
  padding: 0;
  max-height: 200px;
  overflow-y: auto;
  z-index: 10;
}

.suggestions li {
  padding: 10px 12px;
  cursor: pointer;
  transition: background 0.2s;
}

.suggestions li:hover {
  background: #f0f0f0;
}

html[data-theme="dark"] .suggestions {
  background: #2b2b2b;
  color: #eee;
  border-color: #555;
}

.coordinates-display {
  margin-top: 10px;
  font-size: 14px;
  color: #666;
  background: #f7f7f7;
  padding: 10px 14px;
  border-radius: 12px;
}

html[data-theme="dark"] .coordinates-display {
  background: #333;
  color: #ccc;
}
</style>